import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./Table.module.css";

export default class List extends Component {
  renderLoadMore() {
    const { isFetching } = this.props;
    return (
      <tr>
        <td>{isFetching ? "Loading..." : "Load More"}</td>
      </tr>
    );
  }

  render() {
    const {
      isFetching,
      nextPageUrl,
      pageCount,
      items,
      renderItem,
      loadingLabel,
    } = this.props;

    const isEmpty = items.length === 0;

    if (isEmpty && isFetching) {
      return <div>{loadingLabel}</div>;
      return (
        <div>
          <i>
            -{isEmpty}+{isFetching}-A{loadingLabel}
          </i>
        </div>
      );
    }

    const isLastPage = !nextPageUrl;
    if (isEmpty && isLastPage) {
      return <div>No results</div>;
    }

    return (
      <table className={styles.default} style={{ width: "100%" }}>
        <tbody>
          {items.map(renderItem)}
          {pageCount > 0 && !isLastPage && this.renderLoadMore()}
        </tbody>
      </table>
    );
  }
}

List.propTypes = {
  loadingLabel: PropTypes.string.isRequired,
  pageCount: PropTypes.number,
  renderItem: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
  nextPageUrl: PropTypes.string,
};

List.defaultProps = {
  isFetching: true,
  loadingLabel: "Loading...",
};
